var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HorseTable',{staticClass:"mt-4 pr-2",attrs:{"headers":_vm.headers,"title":"Historique des événements","table-items":_vm.filteredSessionByType}})}
var staticRenderFns = []

export { render, staticRenderFns }